import { useState } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Box,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Popover,
  FormGroup,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  MoreHoriz as MoreHoriz,
} from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./card.scss";
import Label from "../Label/Label";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function SampleAccordionList({
  data,
  openData,
  handleClick,
  handleMenuOptionCallBack,
  moreOption,
  handleMenuClick,
  batchData,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [menuItemLabel, setMenuItemLabel] = useState(null);
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorE2);

  const handleChildMenuClick = (event, label) => {
    event.stopPropagation(); // prevent expanding when clicking dots
    setAnchorE2(event.currentTarget);
    setMenuItemLabel(label);
  };

  const handleChildMenuClose = () => {
    setAnchorE2(null);
    setMenuItemLabel(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuItemLabel(null);
  };

  const handleMenuOption = (option, item) => {
    handleMenuOptionCallBack(option, item);
    handleMenuClose();
    handleChildMenuClose();
  };

  const [anchorFilter, setAnchorFilter] = useState(null);
  const openFilter = Boolean(anchorFilter);
  const handleClickFilter = (event) => {
    setAnchorFilter(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setAnchorFilter(null);
  };

  // const handleCheckboxChange = (option) => {
  //   setSelectedFilters((prev) =>
  //     prev.includes(option)
  //       ? prev.filter((item) => item !== option)
  //       : [...prev, option]
  //   );
  // };

  return (
    <Paper elevation={1} className="sample-container" sx={{ height: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Label padding="12px 12px 1px 12px" text="Uploaded Data"></Label>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Label
          padding="12px 14px 12px 12px"
          text={"Batch ID : " + batchData?.batch_id}
        ></Label>
      </Box>
      <List component="nav" disablePadding>
        {data &&
          data?.data?.sheets?.map((item, index) => (
            <Box key={index} className="sample-box">
              <ListItemButton
                className={`menu-list-item ${
                  openData === item.sheet_id ? "active" : ""
                }`}
                onClick={(e) => handleMenuClick(item)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <ListItemText
                  primary={item.name}
                  className="list-item-text"
                  primaryTypographyProps={{
                    sx: {
                      color: openData === item.sheet_id ? "#fff" : "black",
                      cursor: "pointer",
                      width: "100%",
                    },
                  }}
                ></ListItemText>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {/* {item?.table_names_list?.length > 0 &&
                  (openData === item.label ? ( */}
                  <>
                    {/* <IconButton
                      size="small"
                      onClick={(e) => handleMenuClick(e, item.unit_op_id)}
                    >
                      <MoreHoriz
                        sx={{
                          color: openData === item.sheet_id ? "#fff" : "black",
                        }}
                      />
                    </IconButton> */}
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleMenuClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      className="more-horiz-menu"
                    >
                      {moreOption?.map((option) => (
                        <MenuItem
                          sx={{ py: 0.4 }}
                          key={option}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMenuOption(option, item);
                          }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                  {/* ) : (
                    <IconButton onClick={() => handleClick(item)}>
                      <ExpandMore sx={{ color: "#666" }} />
                    </IconButton>
                  ))} */}
                </Box>
              </ListItemButton>

              {/* {item?.table_names_list?.length > 0 && (
              <Collapse
                in={openData === item.label}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {item?.table_names_list?.map((subItem, subIdx) => (
                    <ListItemButton
                      key={subIdx}
                      className={`sub-item ${
                        childData === subItem ? "active" : ""
                      }`}
                    >
                      <ArrowDropDownIcon
                        className="icon-rotate"
                        sx={{
                          color: childData === subItem ? "#fff" : "black",
                        }}
                      />
                      <ListItemText
                        onClick={() => handleChildClick(subItem)}
                        primary={subItem}
                        primaryTypographyProps={{
                          sx: {
                            color: childData === subItem ? "#fff" : "black",
                          },
                        }}
                      />
                      <>
                        <IconButton
                          size="small"
                          onClick={(e) => handleChildMenuClick(e, subItem)}
                        >
                          <MoreHoriz
                            sx={{
                              color: childData === subItem ? "#fff" : "black",
                            }}
                          />
                        </IconButton>
                        <Menu
                          anchorEl={anchorE2}
                          open={open2}
                          onClose={handleChildMenuClose}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          className="more-horiz-menu-child"
                        >
                          {["Add Limit"].map((option) => (
                            <MenuItem
                              key={option}
                              sx={{ py: 0.5 }}
                              onClick={() =>
                                handleMenuOption(option, menuItemLabel)
                              }
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Menu>
                      </>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )} */}
            </Box>
          ))}
      </List>

      {/* Options Menu */}
    </Paper>
  );
}
